module.exports = __webpack_public_path__ + "static/media/basel-36.05cc94ca.jpg";